<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="incomplete-registration">
        <div class="incomplete-registration__icon">
          <img src="../../assets/icons/Warning.svg" alt="info" />
        </div>
        <span class="title title__center">Complete your registration</span>
        <p class="incomplete-registration__message">
          We recognize your email, but you have not completed registration for Carbon Zero. Please take a few minutes to finish registration
          in order to complete your purchase.
        </p>
        <div class="incomplete-registration__ctas">
          <div class="btn btn__primary btn--lg">
            <a :href="customerPortal">Finish registration on Carbon Zero</a>
          </div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import Popup from '@/components/cards/popup/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}

const customerPortal = computed(() => store.state.customerPortaAddress)
</script>
